// src/components/features/widgets/WidgetModalAddYourDomain/WidgetModalAddYourDomain.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ModalTitle, PopupInnerVerticalStretch } from '@/components/atoms/UI/Modal/styles';
import Grid from '@/components/molecules/Grid';
import Icon from '@/components/atoms/UI/Icon/Icon';
import Button from '@/components/atoms/UI/buttons/Button';
import { useSelector } from 'react-redux';
import { selectAllowDomains } from '@/store/selectors/domainsListSelector';
import WidgetAddDomain from '@/components/features/widgets/WidgetAddDomain/WidgetAddDomain';

type Props = {
	onNextClick: () => void;
};

const WidgetModalAddYourDomain: React.FC<Props> = ({ onNextClick }) => {
	const domainList = useSelector(selectAllowDomains);
	const { t } = useTranslation();

	const text_find_more = t('widget.find_more');
	const text_next = t('widget.next');
	const text_title = t('widget.title');

	return (
		<PopupInnerVerticalStretch>
			<Grid col='1' gap='3' centeredContent centeredText>
				<ModalTitle>{text_title}</ModalTitle>
				<WidgetAddDomain />
			</Grid>

			<Grid col='1' gap='2' centeredContent>
				<Button link autoWidth>
					{text_find_more}
					<Icon name={'Next'} small />
				</Button>
				<Button disabled={domainList.length === 0} onClick={onNextClick}>
					{text_next}
				</Button>
			</Grid>
		</PopupInnerVerticalStretch>
	);
};

export default React.memo(WidgetModalAddYourDomain);
